import DeteriorationModelsStore from './deteriorationModels.reducer';
import FailureDefinitionsStore from './failureDefinition.reducer';
import FailureGradeStoreState from './failureGrade.reducer';
import GroupSetsStore from './groupSets.reducer';
import InspectionTypesStore from './inspections.reducer';
import RehabStore from './rehab.reducer';
import AssetBreakDownChartStoreState from './assetBreakDown.reducer';
import util from './util.reducer';

import { combineReducers } from 'redux';

export default combineReducers({
	DeteriorationModelsStore,
	FailureDefinitionsStore,
	FailureGradeStoreState,
	AssetBreakDownChartStoreState,
	GroupSetsStore,
	InspectionTypesStore,
	RehabStore,
	util,
});
